/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 周年庆数据 http://wiki.xunlei.cn/pages/viewpage.action?pageId=120402510
export const meindiaPageInfo = createAsyncThunk(
  'meindia_page_info',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/meindia_page_info', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 领取周年庆奖励 http://wiki.xunlei.cn/pages/viewpage.action?pageId=120402505
export const meindiaReward = createAsyncThunk(
  'meindia_reward',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/meindia_reward', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 发祝福语 http://wiki.xunlei.cn/pages/viewpage.action?pageId=120402521
export const meindiaBless = createAsyncThunk(
  'meindia_bless',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/meindia_bless', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export enum REWARDSTATUS {
  未领取 = 0,
  已领取 = 1,
}

const initialState: {
  annual_reward_status: REWARDSTATUS // 周年奖励领取状态;0:未领取;1:已领取
  share_jobs?: {
    share_uid: string // 分享id
    job_icon: string // 任务icon
    job_text: string // 任务文本
    job_status: number // 任务状态 0:未完成;1:已完成
  }[] // 分享任务
  bless_wall?: {
    mid: number // 用户id
    avatar: string // 用户头像
    text: string // 祝福语
  }[]
  bless_times: number // 剩余祝福次数
  hall_frames?: {
    hall_type: number // 名人堂类型
    hall_name: string // 名人堂名称
    level_infos: {
      level: number // 等级
      level_name: string // 名称
      backgroud_icon: string // 名人堂背景
      banner_icon: string // 名人堂头框
      members: {
        name: string
        mid: number
        zy_id: string
        avatar: string
      }[]
      member_titles: any
    }[]
  }[]
  default_type?: number // 初始名人堂类型
  default_level?: number // 初始名人堂等级
  vipers?: {
    name: string
    avatar: string
    voice: string
  }[] // 大R用户列表
} = {
  annual_reward_status: REWARDSTATUS.已领取,
  bless_times: 0,
  default_type: 0,
  default_level: 0,
}

export const YearPinXuanSlice = createSlice({
  name: 'YearPinXuan',
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<number>) => {
      Object.assign(state, {
        annual_reward_status: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(meindiaPageInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
  },
})

export default YearPinXuanSlice.reducer
export const YearPinXuanSliceActions = YearPinXuanSlice.actions
